module.exports = __webpack_public_path__ + "img/upgrade-icon.1cff934c.svg";